import type { AutocompleteProps as MuiAutocompleteProps } from '@mui/material/Autocomplete/Autocomplete';
import type { TextFieldProps as MuiTextFieldProps } from '@mui/material/TextField/TextField';
import MuiAutocomplete from '@mui/material/Autocomplete/Autocomplete';
import type { FC } from 'react';
import { TextField } from '@components/atoms';

export interface AutocompleteProps
  extends Omit<MuiAutocompleteProps<string, boolean, boolean, boolean>, 'disablePortal' | 'renderInput'> {
  name: string;
  textFieldProps?: MuiTextFieldProps;
}

export const Autocomplete: FC<AutocompleteProps> = ({ options, textFieldProps, ...props }) => {
  return (
    <MuiAutocomplete
      options={options}
      renderInput={params => <TextField name={props.name} {...textFieldProps} {...params} />}
      {...props}
    />
  );
};
